/**
 * Determines the applicable price based on room, table, and time context
 * @param {Array} rulesArray - Array of pricing rule objects
 * @param {Object} context - The context containing room, table, and time
 * @returns {number|null} - The applicable price or null if no rule matches
 */
export function getRulePrice(rulesArray, context) {
  const { room, table, time } = context;
  const currentTime =
    time instanceof Date ? time.getHours() * 60 + time.getMinutes() : null;

  let applicablePrice = null;

  // Filter for active rules only
  const activeRules = rulesArray.filter(rule => rule.status === "active");

  for (const rule of activeRules) {
    // Skip if room doesn't match (unless rule.room is "*")
    if (rule.room !== "*" && rule.room !== room) continue;
    
    // Skip if table doesn't match (unless rule.table 
    if (rule.table !== "*" && rule.table !== table) continue;

    // Handle time constraints
    if (rule.startTime !== "*" && currentTime !== null) {
      const ruleStartTime = parseTime(rule.startTime);
      
      // If there's an end time, check if current time is within range
      if (rule.endTime) {
        const ruleEndTime = parseTime(rule.endTime);
        if (currentTime < ruleStartTime || currentTime > ruleEndTime) continue;
      } 
      // If no end time but start time exists, just check if current time is after start time
      else if (currentTime < ruleStartTime) {
        continue;
      }
    }

    // If we've made it here, the rule applies
    applicablePrice = parseFloat(rule.price);
    break; // Use the first matching rule
  }

  return applicablePrice;

  function parseTime(timeStr) {
    if (!timeStr || timeStr === "*") return null;
    
    const [time, meridian] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (meridian === "PM" && hours !== 12) hours += 12;
    if (meridian === "AM" && hours === 12) hours = 0;
    return hours * 60 + minutes;
  }
}